import React, { Fragment } from "react";
import {
  FormBlock,
  FormTitle,
  BlockFormMain,
  FormRow,
  HalfBlock,
  FormName,
  ActionForm,
} from "../../../generalStyles/mixin";
import InputComponent from "../../inputText";
import SelectComponent from "../../selectInput";
import Buttons from "../../button";
import InputError from "../../inputError";
import InputDateComponent from "../../inputDate";
import {
  getTaskOptions,
  getStateOptions,
  getEngineOptions,
  getFinishMaxDate,
} from "./../../utils/utils";
import * as env from "../../../environment";
import ReactTable from "react-table";
import Pagination from "../../pagination/pagination";
import { TableTitle } from "../../pagination/styles";
import "react-table/react-table.css";
import "../../pagination/styles.css";
import { format } from "date-fns";
import Modal from "../../modal";
import Template from "../../modal/tempalte";
//import { Link } from "react-router-dom";
import styled from "styled-components";
import DetailComponent from '../../detail';
//import DownloadData from "../../button/download-data";
const WIDTH_CELL_CHECKBOX = 30;
const WIDTH_CELL_BUSINESSID = 100;
const WIDTH_CELL_DESCRIPTION = 180;
const WIDTH_CELL_ACTION = "100%";
const WIDTH_CELL_ACTION_NAME = 200;
const WIDTH_CELL_STATUS_DATE = 200;
const BtnAction = styled.span`
  background: #f6f6f6;
  color: #292929;
  margin: 0px 2px;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  padding: 10px 10px;
  cursor: pointer;
  &:hover {
    color: #070707;
    background-color: #f1f1f1;
  }
`;
const { API_URL_MOTOR, API_URL_MOTOR_8080 } = env[process.env.NODE_ENV];

class ErrorComponent extends React.Component {
  constructor(props) {
    super(props);
    let dataTable = '';
    this.state = {
      token: localStorage.getItem("token"),
      isOpen: false,
      modalChildren: "",
      isClosable: false,

      data: [],
      operationNumber: "",
      startDate: "",
      endDate: "",
      statusSelected: "",

      flowsSelected: "",

      taskSelected: "",
      statusBoxes: [],
      contextBoxes: [],
      taskBoxes: [],
      paginator: "",

      pageSize: 10,
      paginatorDownload: 0,
      dataDownload: [],
      showPrepare: false,

      sOperationNumber: false,
      sStartDate: false,
      sEndDate: false,
      sProcessId: false,
      mOperationNumber: "",
      mStartDate: "",
      mEndDate: "",
      mProcessId: "",

      //empuje masivo
      selected: {},
      selectAll: 0,

      idOrder: "",
      engineId: "",
      visible: true,
    };

    //this.toggleRow = this.toggleRow.bind(this);
  }

  /**
   * Utilizado para empujes masivos
   * @param {*} businessId 
   */
  toggleRow = (businessId) => {
    const newSelected = Object.assign({}, this.state.selected);
    newSelected[businessId] = !this.state.selected[businessId];
    this.setState({
      selected: newSelected,
      selectAll: 2
    });
  }

  /**
   * Utilizado para empujes masivos
   */
  toggleSelectAll() {
    let newSelected = {};

    if (this.state.selectAll === 0) {
      this.state.data.forEach(x => {
        newSelected[x.businessId] = true;
      });
    }

    this.setState({
      selected: newSelected,
      selectAll: this.state.selectAll === 0 ? 1 : 0
    });
  }

  getStatusArray() {
    let apiUrlEngineContext = `${API_URL_MOTOR}/api/engine/statustype/all`;
    let endpoint = apiUrlEngineContext;
    let optionsResponse = getStateOptions(endpoint, "name", "codStatus");
    this.setState({ statusBoxes: optionsResponse });
  }

  getContextArray() {
    let apiUrlEngineContext = `${API_URL_MOTOR}/api/engine/context/all`;

    let endpoint = apiUrlEngineContext;
    let optionsResponse = getEngineOptions(endpoint, "name", "idContext");
    this.setState({ contextBoxes: optionsResponse });
  }

  getTaskOptions(idContext) {
    let apiUrlEngineTask = `${API_URL_MOTOR}/api/engine/task/`;
    let endpoint = apiUrlEngineTask + idContext;
    let optionsResponse = getTaskOptions(endpoint, "name", "idContext");
    this.setState({ taskBoxes: optionsResponse, taskSelected: "" });
  }
  componentDidMount() {
    this.getStatusArray();
    this.getContextArray();
  }

  handlerVisible = (visible) => {
    this.setState({
      visible: visible
    });
  }

  render() {
    if (localStorage.getItem('perfiles').includes('Admin')) {
      const columns = [
        {
          id: "checkbox",
          accessor: "",
          Cell: ({ original }) => {
            return (
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selected[original.businessId] === true}
                onChange={() => this.toggleRow(original.businessId)}
              />
            );
          },
          Header: x => {
            return (
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selectAll === 1}
                ref={input => {
                  if (input) {
                    input.indeterminate = this.state.selectAll === 2;
                  }
                }}
                onChange={() => this.toggleSelectAll()}
              />
            );
          },
          sortable: false,
          width: 45
        },
        {
          Header: "Business ID",
          accessor: "businessId",
          sortable: false,
          width: WIDTH_CELL_BUSINESSID,
          style: { whiteSpace: "unset", paddingTop: 15 },
        },
        {
          Header: "Tarea",
          accessor: "actionName",
          sortable: false,
          width: WIDTH_CELL_ACTION_NAME,
          style: { whiteSpace: "unset", paddingTop: 15 },
        },
        {
          Header: "Descripción",
          accessor: "description",
          sortable: false,
          width: WIDTH_CELL_DESCRIPTION,
          style: { whiteSpace: "unset", paddingTop: 15 },
        },
        {
          Header: "Fecha/Hora Error",
          accessor: "statusDate",
          sortable: false,
          width: WIDTH_CELL_STATUS_DATE,
          style: { whiteSpace: "unset", paddingTop: 15 },
        }
      ];

      return (
        <Fragment>
          {this.state.visible ? (
            <form onSubmit={this.handleSubmit}>
              <FormBlock>
                <FormTitle>Consulta Instancias con Error</FormTitle>
                <BlockFormMain>
                  <HalfBlock>
                    <FormRow>
                      <FormName>Número operación</FormName>
                      <InputComponent
                        onChange={this.onChange}
                        value={this.state.operationNumber}
                        name="operationNumber"
                      />
                    </FormRow>
                    <InputError
                      isShow={this.state.sOperationNumber}
                      value={this.state.mOperationNumber}
                    />
                    <FormRow>
                      <FormName>Fecha de Inicio</FormName>
                      <InputDateComponent
                        onChange={this.onChangeStartDate}
                        ref="startDate"
                      />
                    </FormRow>
                    <InputError
                      isShow={this.state.sStartDate}
                      value={this.state.mStartDate}
                    />
                    <FormRow>
                      <FormName>Fecha de Termino</FormName>
                      <InputDateComponent
                        onChange={this.onChangeEndDate}
                        ref="finishDate"
                      />
                    </FormRow>
                    <InputError
                      isShow={this.state.sEndDate}
                      value={this.state.mEndDate}
                    />
                    <FormRow>
                      <FormName>Nombre de Archivo</FormName>
                      <InputComponent
                        onChange={this.onChange}
                        value={this.state.processId}
                        name="processId"
                      />
                    </FormRow>
                    <InputError
                      isShow={this.state.sProcessId}
                      value={this.state.mProcessId}
                    />
                  </HalfBlock>

                  <HalfBlock>
                    <FormRow>
                      <FormName>Estado</FormName>
                      <SelectComponent
                        options={this.state.statusBoxes}
                        onChange={this.onChangeBoxesStatus}
                        ref="selectState"
                      />
                    </FormRow>
                    <FormRow>
                      <FormName>Flujos</FormName>
                      <SelectComponent
                        options={this.state.contextBoxes}
                        onChange={this.onChangeBoxesFlows}
                        ref="selectFlow"
                      />
                    </FormRow>
                    <FormRow>
                      <FormName>Tarea</FormName>
                      <SelectComponent
                        options={this.state.taskBoxes}
                        onChange={this.onChangeBoxesTask}
                        ref="selectTask"
                      />
                    </FormRow>
                  </HalfBlock>
                </BlockFormMain>
                <ActionForm>
                  <Buttons.Primary>Buscar</Buttons.Primary>
                  <Buttons.Clear
                    type="none"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        operationNumber: "",
                        startDate: "",
                        endDate: "",
                        statusSelected: "",
                        flowsSelected: "",
                        taskSelected: "",
                        sOperationNumber: false,
                        sStartDate: false,
                        sEndDate: false,
                        sProcessId: false,
                      });
                      this.refs.startDate.setState({ startDate: "" });
                      this.refs.finishDate.setState({ startDate: "" });
                      this.refs.selectTask.setState({ selectedOption: null });
                      this.refs.selectFlow.setState({ selectedOption: null });
                      this.refs.selectState.setState({ selectedOption: null });
                      this.state.selected = {};
                      this.state.selectAll = 0;
                    }}
                  >
                    Limpiar
                </Buttons.Clear>
                </ActionForm>
              </FormBlock>
            </form>
          ) : (
            <Fragment>
              <TableTitle>SECCION DE DETALLES</TableTitle>
              <DetailComponent action={this.handlerVisible}
                otroDato={{ idOrder: this.state.idOrder, engineId: this.state.engineId }}></DetailComponent>
            </Fragment>
          )}

          {this.state.data.length > 0 ? (
            <TableTitle>Resultado de Búsqueda</TableTitle>
          ) : (
            ""
          )}
          {this.state.data.length > 0 ? (

            <Fragment>
              <select
                style={{ border: "1px solid #CCC", cursor: "pointer", width: "200px", padding: "5px", marginBottom: "10px", fontSize: "14px" }}
                value={this.state.pageSize}
                onChange={e => {
                  this.setState({ data: [] })
                  this.setPageSize(Number(e.target.value))
                }}>
                {
                  [10, 25, 50, 100].map(pageSize => (
                    <option key={pageSize} value={pageSize}>
                      Mostrando: {pageSize}
                    </option>
                  ))
                }
              </select>
              <ReactTable
                PaginationComponent={Pagination}
                getTdProps={this.onRowClicks}
                data={this.state.data}
                previousText={"anterior"}
                nextText={"siguiente"}
                noDataText={"No hay registros"}
                pages={(this.state.paginator != null)? this.state.paginator.totalPageNumber: 1}
                canNext={(this.state.paginator != null && this.state.paginator.totalPageNumber > 1) ? true : false}
                manual
                onFetchData={this.handlePageChange}

                defaultPageSize={
                  this.state.data.length >= 10 ? 10 : this.state.data.length
                }
                resizable={false}
                columns={columns}
                style={{ textAlign: "center" }}
                className="-striped -highlight"
              />
            </Fragment>
          ) : null}

          {Object.keys(this.state.selected).length > 0 ? (
            // <Buttons.Primary type="none" onClick={(e) => { e.preventDefault(); this.reinjectMasiveBtn(this.state.data) }}>Empujar</Buttons.Primary>
            <Buttons.Primary type="none" onClick={(e) => { e.preventDefault(); this.reinjectMasiveBtn(this.dataTable) }}>Empujar</Buttons.Primary>
          ) : null}
          <Modal
            show={this.state.isOpen}
            onClose={() => {
              this.state.isClosable
                ? this.setState({
                  isOpen: !this.state.isOpen,
                })
                : console.warn("worker on something...");
            }}
          >
            <Template name={this.state.modalChildren} />
          </Modal>
        </Fragment>
      );
    } else {
      this.props.history.push('/home/consult/estadoPago');
      return "";
    }
  }

  setPageSize = (e) => {
    console.clear()
    console.log('eeeeeeeee', e)
    this.setState({ pageSize: e });

    let endpoint = `${API_URL_MOTOR}/api/error/find`;
    this.searchErrors(endpoint, e);
  }

  handleSubmit = (e) => {
    e.preventDefault();

    // Limpiamos seleccionados anteriores
    this.state.selected = {};
    this.state.selectAll = 0;
    this.state.pageSize = 10;
    this.setState({ data: [], dataDownload: [], showPrepare: false });

    if (!this.validation(this.state)) {
      console.warn("invalid data");
      return;
    }
    let endpoint = `${API_URL_MOTOR}/api/error/find`;
    this.searchErrors(endpoint, this.state.pageSize);
  };

  handlePageChange = async (tableState, _instance) => {
    console.log('tableState.page: ' + tableState.page);
    const pageNum = tableState.page + 1;
    await this.toPage(pageNum, this.state.pageSize);
  }

  toPage(page, pageSize) {
    if (this.state.paginator != "") {
      this.state.paginator.currentPageNumber = page;
    }
    let endpoint = `${API_URL_MOTOR}/api/error/find`;
    this.searchErrors(endpoint);
  }

  dataExcel = async () => {
    let endpoint = `${API_URL_MOTOR}/api/error/find`;
    let datos = await this.dataMatch(endpoint)

    if (!datos) {
      console.log('LISTO PARA EXPORTAR!')
      console.log(this.state.dataDownload)
      this.setState({ showPrepare: true, paginatorDownload: 0 });
    }
  }

  dataMatch = async (endpoint) => {
    let request = this.generateRequestDownload(true);
    console.log('request', request)
    var json = JSON.stringify(request);
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        //Authorization: this.state.token,
      },
      body: JSON.parse(json),
    };

    this.setState({
      isOpen: true,
      modalChildren: "loader",
      isClosable: false,
    });


    let result = await fetch(endpoint, requestOptions);
    let data = await result.json();
    let searchResult = this.generateData(data);

    if (searchResult.length > 0) {
      console.log('Hay Datos! Nro de pagina: ', this.state.paginatorDownload)
      searchResult.map(res => {
        this.state.dataDownload.push(res);
      });

      this.setState({
        isOpen: false,
        modalChildren: "",
        isClosable: false,
      });

      return await this.dataMatch(endpoint);
    } else {
      this.setState({
        isOpen: false,
        modalChildren: "",
        isClosable: false,
      });
      return false;
    }
  }

  generateRequestDownload(withPaginator) {
    let request = "{";

    if (withPaginator == true) {
      let currentPage = this.state.paginatorDownload + 1;
      this.setState({ paginatorDownload: currentPage });
      // agregar paginador
      request = request + '"paginator": {"currentPageNumber": ' + currentPage + ', "pageSize": 1000},';
    }

    if (
      this.state.operationNumber !== undefined &&
      this.state.operationNumber !== "" &&
      this.state.operationNumber !== "-1"
    ) {
      request = request + '"businessId": "' + this.state.operationNumber + '",';
    } else {
      request = request + '"businessId": null,';
    }
    if (
      this.state.endDate !== undefined &&
      this.state.endDate !== "" &&
      this.state.endDate !== null
    ) {
      request =
        request +
        '"errorDateEnd": "' +
        format(new Date(this.state.endDate), "yyyy-MM-dd") +
        '",';
    } else {
      request = request + '"errorDateEnd": null,';
    }
    if (
      this.state.startDate !== undefined &&
      this.state.startDate !== "" &&
      this.state.startDate !== null
    ) {
      request =
        request +
        '"errorDateStart": "' +
        format(new Date(this.state.startDate), "yyyy-MM-dd") +
        '",';
    } else {
      request = request + '"errorDateStart": null,';
    }
    if (
      this.state.flowsSelected !== undefined &&
      this.state.flowsSelected !== "" &&
      this.state.flowsSelected !== "-1"
    ) {
      request = request + '"idContext": ' + this.state.flowsSelected + ",";
    } else {
      request = request + '"idContext": 0,';
    }
    if (
      this.state.statusSelected !== undefined &&
      this.state.statusSelected !== "" &&
      this.state.statusSelected !== "-1"
    ) {
      request = request + '"idStatusType": ' + this.state.statusSelected + ",";
    } else {
      request = request + '"idStatusType": 0,';
    }
    if (
      this.state.taskSelected !== undefined &&
      this.state.taskSelected !== "" &&
      this.state.taskSelected !== "-1"
    ) {
      request = request + '"taskName": "' + this.state.taskSelected + '",';
    } else {
      request = request + '"taskName": null,';
    }

    if (
      this.state.processId !== undefined &&
      this.state.processId !== "" &&
      this.state.processId !== "-1"
    ) {
      request = request + '"processId": "' + this.state.processId + '",';
    } else {
      request = request + '"processId": null,';
    }

    request = request.substring(0, request.length - 1);
    request = request + "}";

    return request;
  }



  generateRequest(withPaginator, pageSize) {
    let request = "{";

    if (withPaginator == true) {
      let currentPage = 1;
      if (this.state.paginator != null && this.state.paginator != "" && pageSize === this.state.pageSize) {
        currentPage = this.state.paginator.currentPageNumber;
      }
      // agregar paginador
      request = request + '"paginator": {"currentPageNumber": ' + currentPage + ', "pageSize": ' + pageSize + '},';
    }

    if (
      this.state.operationNumber !== undefined &&
      this.state.operationNumber !== "" &&
      this.state.operationNumber !== "-1"
    ) {
      request = request + '"businessId": "' + this.state.operationNumber + '",';
    } else {
      request = request + '"businessId": null,';
    }
    if (
      this.state.endDate !== undefined &&
      this.state.endDate !== "" &&
      this.state.endDate !== null
    ) {
      request =
        request +
        '"errorDateEnd": "' +
        format(new Date(this.state.endDate), "yyyy-MM-dd") +
        '",';
    } else {
      request = request + '"errorDateEnd": null,';
    }
    if (
      this.state.startDate !== undefined &&
      this.state.startDate !== "" &&
      this.state.startDate !== null
    ) {
      request =
        request +
        '"errorDateStart": "' +
        format(new Date(this.state.startDate), "yyyy-MM-dd") +
        '",';
    } else {
      request = request + '"errorDateStart": null,';
    }
    if (
      this.state.flowsSelected !== undefined &&
      this.state.flowsSelected !== "" &&
      this.state.flowsSelected !== "-1"
    ) {
      request = request + '"idContext": ' + this.state.flowsSelected + ",";
    } else {
      request = request + '"idContext": 0,';
    }
    if (
      this.state.statusSelected !== undefined &&
      this.state.statusSelected !== "" &&
      this.state.statusSelected !== "-1"
    ) {
      request = request + '"idStatusType": ' + this.state.statusSelected + ",";
    } else {
      request = request + '"idStatusType": 0,';
    }
    if (
      this.state.taskSelected !== undefined &&
      this.state.taskSelected !== "" &&
      this.state.taskSelected !== "-1"
    ) {
      request = request + '"taskName": "' + this.state.taskSelected + '",';
    } else {
      request = request + '"taskName": null,';
    }

    if (
      this.state.processId !== undefined &&
      this.state.processId !== "" &&
      this.state.processId !== "-1"
    ) {
      request = request + '"processId": "' + this.state.processId + '",';
    } else {
      request = request + '"processId": null,';
    }

    request = request.substring(0, request.length - 1);
    request = request + "}";

    return request;
  }

  generateData(response) {
    let searchResponse = [];
    let i = 0;
    if (response.errors !== null) {
      for (i = 0; i < response.errors.length; i++) {
        var fDate = "";
        if (response.errors[i]["finishDate"] != null && response.errors[i]["finishDate"] != "") {
          fDate = format(new Date(response.errors[i]["finishDate"]), "dd/MM/yyyy HH:mm:ss");
        }
        searchResponse.push({
          "businessId": response.errors[i].instance["businessId"],
          "actionName": response.errors[i]["actionName"],
          "description": response.errors[i].statusType["description"],
          "statusDate": format(new Date(response.errors[i]["statusDate"]), "dd-MM-yyyy HH:mm:ss"),
          "idInstance": response.errors[i].instance["idInstance"],
        });
      }
    }
    return searchResponse;
  }

  /**
   * Busqueda de errores
   */
  searchErrors = (endpoint, pageSize) => {
    let searchResponse = [];
    let request = this.generateRequest(true, pageSize);

    // quitar caracteres de escape
    var json = JSON.stringify(request);
    console.log("request : " + JSON.parse(json));
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        //  Authorization: this.state.token,
      },
      body: JSON.parse(json),
    };

    this.setState({
      isOpen: true,
      modalChildren: "loader",
      isClosable: false,
    });

    setTimeout(() => {
      this.setState({
        isOpen: false,
      });
    }, 3000);

    fetch(endpoint, requestOptions)
      .then((result) => {
        if (result.ok) {
          result
            .json()
            .then((response) => {
              this.dataTable = response.errors;
              searchResponse = this.generateData(response);
              this.setState({ data: searchResponse, paginator: response.paginator });
              if (this.state.data === null || this.state.data.length === 0) {
                this.setState({
                  modalChildren: "notFound",
                  isClosable: true,
                });
              } else {
                this.setState({
                  isOpen: false,
                  modalChildren: "",
                  isClosable: false,
                });
              }
            })
            .catch((error) => {
              console.log(
                "Hubo un problema con la petición Fetch:" + error.message
              );
              this.setState({
                isOpen: true,
                modalChildren: "error",
                isClosable: true,
              });
            });
        }
      })
      .catch((error) => {
        console.log("Hubo un problema con la petición Fetch:" + error.message);
        this.setState({
          isOpen: true,
          modalChildren: "error",
          isClosable: true,
        });
      });
  };

  onChange = (e) => {
    this.setState({
      [e.name]: e.value,
    });
  };
  onChangeBoxesStatus = (e) => {
    this.setState({
      statusSelected: e.value,
    });
  };

  onChangeBoxesFlows = (e) => {
    this.setState({
      flowsSelected: e.value,
    });
    // Cargamos tareas segun contexto seleccionado
    this.refs.selectTask.setState({ selectedOption: null });
    this.getTaskOptions(e.value);
  };
  onChangeBoxesTask = (e) => {
    this.setState({
      taskSelected: e.label,
    });
  };
  onChangeStartDate = (e) => {
    this.setState({
      startDate: e,
    });

    this.refs.finishDate.setState({
      maxDate: new Date(getFinishMaxDate(e)),
      minDate: e,
      startDate: "",
    });
  };
  onChangeEndDate = (e) => {
    this.setState({
      endDate: e,
    });
  };
  validation = (state) => {
    const { operationNumber, startDate, endDate } = state;
    if (startDate === null || endDate === null) {
      this.setState({
        sOperationNumber: true,
        mOperationNumber: "Campo es Obligatorio",
        sStartDate: true,
        mStartDate: "Campo es Obligatorio",
        sEndDate: true,
        mEndDate: "Campo es Obligatorio",
        sProcessId: true,
        mProcessId: "Campo Obligatorio",
      });
      return false;
    }
    if (operationNumber !== "" || startDate !== "" || endDate !== "") {
      this.setState({
        sOperationNumber: false,
        mOperationNumber: "",
        sStartDate: false,
        mStartDate: "",
        sEndDate: false,
        mEndDate: "",
        sProcessId: false,
        mProcessId: "",
      });
      return true;
    } else {
      this.setState({
        sOperationNumber: true,
        mOperationNumber: "Campo es Obligatorio",
        sStartDate: true,
        mStartDate: "Campo es Obligatorio",
        sEndDate: true,
        mEndDate: "Campo es Obligatorio",
        sProcessId: true,
        mProcessId: "Campo Obligatorio",
      });
      return false;
    }
  };

  // reinyectar masivamente
  reinjectMasiveBtn(data) {
    let count = Object.keys(this.state.selected).length;

    if (count > 1) {
      let errorjson = [];
      Object.keys(this.state.selected).forEach((element) => {
        var dataError = data.filter((value) => {
          return value.instance.businessId === element;
        });

        errorjson.push(dataError[0]);
      });

      this.reinjectBtn(errorjson);
    } else {
      Object.keys(this.state.selected).forEach((element) => {

        // Buscar respuesta errores con bussinessid de la busqueda
        var errorjson = data.filter(function (value) {
          return value.instance.businessId === element;
        });

        // empujamos el registro encontrado
        this.reinjectBtn(errorjson);
      });

    }

    // Limpiamos la búsqueda
    this.state.selected = {};
    this.state.selectAll = 0;
    this.state.data = [];
  }

  // reinyectar individualmente
  reinjectBtn(data) {
    console.log("DATA FINAL", data)
    let apiUrlEngineContext = `${API_URL_MOTOR_8080}/api/instance/reinject`;

    let a = "{";
    a += '"trxContext": {';
    a += '"uuid": "' + data[0].context.uuid + '",';
    a += '"version": "' + data[0].context.version + '"';
    a += '},';

    a += '"trxIdentify": {';
    a += '"idInstance": ' + data[0].instance.idInstance + ',';
    a += '"idError": ' + data[0].idError + ',';
    a += '"businessId": "' + data[0].instance.businessId + '"';
    a += '},';

    a += '"trxInject": {';
    a += '"type": "CONTINUE",';
    a += '"origin": "' + data[0].actionName + '"';
    a += '}';
    a += '}';

    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: a,
    };

    fetch(apiUrlEngineContext, requestOptions)
      .then((result) => {
        console.log(result);
        if (result.ok) {
          result
            .json()
            .then((response) => {
              console.log(response);

              data.shift();
              console.log("CUANTA DATA VA", data)

              if (data.length > 0) {
                // modal exito
                this.setState({
                  isOpen: true,
                  modalChildren: "loader",
                  isClosable: false,
                });
                return this.reinjectBtn(data);
              } else {
                // modal exito
                this.setState({
                  isOpen: true,
                  modalChildren: "success",
                  isClosable: true,
                });
              }
            })
            .catch((error) => {
              console.log("Hubo un problema con la petición Fetch:" + error.message);
              // modal exito
              this.setState({
                isOpen: true,
                modalChildren: "error",
                isClosable: true,
              });
            });
        }
      })
      .catch((error) => {
        console.log("Hubo un problema con la petición Fetch:" + error.message);
      });
  }

  onRowClicks = (state, rowInfo, instance) => {
    return {
      onClick: () => {
        this.setState({
          visible: false,
          idOrder: rowInfo.row._original.businessId,
          engineId: rowInfo.row._original.idInstance
        });
      }
    }
  }

}
export default ErrorComponent;
